// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63ab94c0","239":"f338f6af","667":"0c85eef1"}[chunkId] + ".chunk.js";
};